import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../shared/mutators";
import { currentSourcePage } from "../lib/sourcePage";

const LIST_PAGES = new Set([
  "recents",
  "favorites",
  "personal",
  "links",
  "space",
  "space_links",
]);

export function useRecordListControlChange() {
  const z = useZero();
  return (control: string, value: string) => {
    const page = currentSourcePage();
    if (!LIST_PAGES.has(page)) return;
    z.mutate(sharedMutators.recordListControlChange({ page, control, value }));
  };
}
